"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var localeCode_1 = require("./localeCode");
exports.LocaleCode = localeCode_1.LocaleCode;
var AttensiEnvironment;
(function (AttensiEnvironment) {
    AttensiEnvironment["PRODUCTION"] = "PRODUCTION";
    AttensiEnvironment["STAGING"] = "STAGING";
    AttensiEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
})(AttensiEnvironment = exports.AttensiEnvironment || (exports.AttensiEnvironment = {}));
var AttensiParam;
(function (AttensiParam) {
    AttensiParam["ACCESS_TOKEN"] = "access_token";
    AttensiParam["API_TOKEN"] = "api_token";
    AttensiParam["ATTENSI_CLIENT"] = "attensi_client";
    AttensiParam["COMPANY_NAME_KEY"] = "company_name_key";
    AttensiParam["ENVIRONMENT"] = "environment";
    AttensiParam["LOCALE"] = "locale";
    AttensiParam["SUBDOMAIN"] = "subdomain";
})(AttensiParam = exports.AttensiParam || (exports.AttensiParam = {}));
var converters_1 = require("./converters");
exports.stringToAttensiClient = converters_1.stringToAttensiClient;
exports.stringToEnvironment = converters_1.stringToEnvironment;
//# sourceMappingURL=index.js.map